/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useEffect, useMemo, useRef, useState } from 'react';

import {
  AccessAutocomplete,
  PrimaryButton,
  SecondaryButton,
  Typography,
} from '@changegps/horizon-component-library';
import { Box } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { ControlledInputs } from '@/components';
import { coreLettersAxiosClient } from '@/lib/axios';

import {
  useGlobalLetterFormContext,
  useInvalidateLetterTemplates,
} from '../../hooks';
import {
  updateSelectedLetterTemplate,
  useSelectedLetterTemplate,
} from '../../store';

interface LetterTemplatesProps {
  data?: any[];
}

interface SaveTemplatePayload {
  category_id: string;
  header: string;
  subheader: string;
  name: string;
  content: string;
}

export const EditLetterTemplates = ({ data }: LetterTemplatesProps) => {
  const form = useGlobalLetterFormContext();
  const { invalidateLetterTemplates } = useInvalidateLetterTemplates();
  const [documents, setDocuments] = useState<any[]>([]);
  const [currentDocuemnt, setCurrentDocument] = useState<any>(null);
  const [selectedCategory, setSelectedCategory] = useState<string>('');
  const [selectedTemplate, setSelectedTemplate] = useState<string>('');
  const selectedLetterTemplate = useSelectedLetterTemplate(selectedTemplate);
  const [_formErrors, setFormErrors] = useState<{
    subject?: string;
    subHeader?: string;
  }>({});
  const originalContentRef = useRef<{
    content: string;
    subject: string;
    subHeader: string;
  } | null>(null);

  const saveLetterMutation = useMutation({
    mutationFn: (formData: SaveTemplatePayload) => {
      return coreLettersAxiosClient.post(
        `/settings/merge/${selectedTemplate}`,
        formData,
      );
    },
    onSuccess: (response) => {
      window.console.log('Template saved successfully:', response);
      toast.success('Changes are updated successfully!');

      const formData = form.getValues();
      const updatedTemplate = {
        id: selectedTemplate,
        name:
          documents.find((doc: any) => doc.id === selectedTemplate)?.name || '',
        content: formData.letter_template?.content || '',
        header: formData.letter_template?.subject || '',
        subheader: formData.letter_template?.sub_header || '',
        category_id: selectedCategory,
      };

      updateSelectedLetterTemplate(selectedTemplate, updatedTemplate);

      originalContentRef.current = {
        content: formData.letter_template?.content || '',
        subject: formData.letter_template?.subject || '',
        subHeader: formData.letter_template?.sub_header || '',
      };

      if (currentDocuemnt && selectedTemplate) {
        const updatedDocuments = currentDocuemnt.map((item: any) => {
          if (item.id === selectedTemplate) {
            return updatedTemplate;
          }
          return item;
        });

        setCurrentDocument(updatedDocuments);
        setDocuments(updatedDocuments);
      }

      invalidateLetterTemplates();
    },
    onError: (error) => {
      window.console.error('Error saving template:', error);
    },
  });

  const categoryOptions = useMemo(() => {
    if (data) {
      return data.map((item: { name: string; id: string }) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
    }
    return [];
  }, [data]);

  const validateForm = () => {
    const formData = form.getValues();
    const errors: { subject?: string; subHeader?: string } = {};
    let isValid = true;

    if (!formData.letter_template?.subject) {
      errors.subject = 'Subject is required';
      isValid = false;
    }

    if (!formData.letter_template?.sub_header) {
      errors.subHeader = 'Sub-header is required';
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };

  const clearFormFields = () => {
    form.setValue('letter_template.content', '');
    form.setValue('letter_template.subject', '');
    form.setValue('letter_template.sub_header', '');
    setFormErrors({});
    originalContentRef.current = null;
  };

  const handleSave = () => {
    if (!validateForm()) {
      return;
    }

    const formData = form.getValues();
    const subject = formData.letter_template?.subject || '';
    const subHeader = formData.letter_template?.sub_header || '';
    const content = formData.letter_template?.content || '';

    const payload: SaveTemplatePayload = {
      category_id: selectedCategory,
      header: subject,
      subheader: subHeader,
      name: selectedTemplate
        ? documents.find((doc: any) => doc.id === selectedTemplate)?.name || ''
        : '',
      content: content,
    };

    saveLetterMutation.mutate(payload);
  };

  const resetToDefault = () => {
    if (originalContentRef.current) {
      form.setValue(
        'letter_template.content',
        originalContentRef.current.content,
      );
      form.setValue(
        'letter_template.subject',
        originalContentRef.current.subject,
      );
      form.setValue(
        'letter_template.sub_header',
        originalContentRef.current.subHeader,
      );
    }
  };

  // Function to find document by ID in current document array
  const findDocumentById = (id: string) => {
    return currentDocuemnt?.find((item: any) => item.id === id);
  };

  useEffect(() => {
    if (selectedTemplate && selectedLetterTemplate) {
      form.setValue('letter_template.content', selectedLetterTemplate.content);
      form.setValue('letter_template.subject', selectedLetterTemplate.header);
      form.setValue(
        'letter_template.sub_header',
        selectedLetterTemplate.subheader,
      );
    }
  }, [selectedTemplate, selectedLetterTemplate, form]);

  return (
    <Box
      sx={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: 2 }}
    >
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
          Category:
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, flexGrow: 1 }}>
          <Box sx={{ flexGrow: 1 }}>
            <AccessAutocomplete
              options={categoryOptions}
              onChange={(_event, value) => {
                clearFormFields();

                if (value) {
                  // Find templates for this category
                  const categoryTemplates =
                    // @ts-expect-error malformed data type
                    data?.find((item: any) => item.id === value.value)
                      ?.templates || [];
                  setDocuments(categoryTemplates);
                  setCurrentDocument(categoryTemplates);
                  // @ts-expect-error malformed data type
                  setSelectedCategory(value.value);
                } else {
                  setDocuments([]);
                  setCurrentDocument(null);
                  setSelectedCategory('');
                }
              }}
              TextFieldProps={{
                placeholder: 'Select a category or document',
              }}
            />
          </Box>
          <Box sx={{ flexGrow: 1 }}>
            <AccessAutocomplete
              key={documents.length}
              options={documents.map((item: { name: string; id: string }) => {
                return {
                  label: item.name,
                  value: item.id,
                };
              })}
              onChange={(_event, value) => {
                if (value) {
                  // @ts-expect-error malformed data type
                  const templateId = value.value;
                  setSelectedTemplate(templateId);

                  const originalTemplate = findDocumentById(templateId);

                  if (originalTemplate) {
                    originalContentRef.current = {
                      content: originalTemplate.content || '',
                      subject: originalTemplate.header || '',
                      subHeader: originalTemplate.subheader || '',
                    };

                    form.setValue(
                      'letter_template.content',
                      originalTemplate.content,
                    );
                    form.setValue(
                      'letter_template.subject',
                      originalTemplate.header,
                    );
                    form.setValue(
                      'letter_template.sub_header',
                      originalTemplate.subheader,
                    );
                  }
                } else {
                  setSelectedTemplate('');
                }
              }}
              TextFieldProps={{
                placeholder: 'Select a document',
              }}
            />
          </Box>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', gap: 2 }}>
        <Box sx={{ width: '100%' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
            Subject:
          </Typography>
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `letter_template.subject`,
            }}
            fullWidth
          />
        </Box>
        <Box sx={{ width: '100%' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
            Sub-header:
          </Typography>
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `letter_template.sub_header`,
            }}
            fullWidth
          />
        </Box>
      </Box>
      <ControlledInputs.TextEditor
        ControllerProps={{
          control: form.control,
          name: `letter_template.content`,
        }}
        modules={{
          toolbar: [
            ['bold', 'italic'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['code-block'],
          ],
        }}
      />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <SecondaryButton>View all merge fields</SecondaryButton>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <SecondaryButton onClick={resetToDefault}>
            Reset to default ChangeGPS content
          </SecondaryButton>
          <PrimaryButton
            onClick={handleSave}
            disabled={saveLetterMutation.isPending}
          >
            {saveLetterMutation.isPending ? 'Saving...' : 'Save'}
          </PrimaryButton>
        </Box>
      </Box>
    </Box>
  );
};
